import translations from './translations'

translations.add('is', {
    header: 'Gefa til góðgerðarmála?',
    donate: 'Gefa',
    thanks: 'Takk fyrir framlag þitt!'
})
